// LICENSE_CODE MIT
// after login go back to the page that needed it: /login?return_to=<path>
let E = {};

// the login url that returns to loc. Already on /login keeps its return_to: a
// 401 there (a request of the page just left) must not nest or lose it
/** @type {(o: any) => string} */
E.login_url_get_e = ({loc=undefined})=>{
  if (loc.pathname == '/login')
    return '/login' + loc.search;
  let path = loc.pathname + loc.search + loc.hash;
  return '/login?return_to=' + encodeURIComponent(path);
};

// the return_to of a url's search, only a page of this site: '//x', '/\x' and
// '/<tab>/x' are other sites
/** @type {(o: any) => string|undefined} */
E.path_get_e = ({search=undefined})=>{
  let path = new URLSearchParams(search).get('return_to');
  if (!/^\/(?![/\\])\S*$/u.test(path))
    return;
  return path;
};

export default E;
